{
  "screen": {
    "sectionHeading": "Unidad y cama",
    "open": "Trasladar paciente",
    "heading": "Trasladar paciente",
    "explanation": "Traslada al paciente a otra unidad o cama. Es el mismo ingreso, por lo que la hora de ingreso no cambia.",
    "from": "El paciente está ahora en {location}, desde {since}.",
    "requiredHint": "Los campos sin indicación son obligatorios.",
    "optional": "opcional",
    "final": "Un traslado no se puede eliminar. La ubicación actual permanece en la historia clínica. Si ha sido un error, vuelva a trasladar al paciente.",
    "save": "Trasladar al paciente",
    "saving": "Trasladando …",
    "cancel": "Cancelar",
    "close": "Cerrar",
    "saved": "El paciente ha sido trasladado a {ward}.",
    "discardQuestion": "¿Cerrar el formulario? El paciente no se trasladará.",
    "discardConfirm": "Cerrar sin trasladar",
    "discardCancel": "Seguir rellenando"
  },
  "field": {
    "ward": "A la unidad",
    "bed": "Cama",
    "movedAt": "Trasladado"
  },
  "fieldHint": {
    "ward": "La unidad a la que se traslada el paciente. También puede ser la misma unidad, para cambiar de cama.",
    "bed": "Habitación y cama tal como las nombra el personal. Déjelo vacío si no hay cama: el paciente aparecerá entonces al final de la lista de la unidad, sin cama.",
    "movedAt": "Cuándo se realizó el traslado, como AAAA-MM-DD HH:MM en formato de 24 horas. Modifíquelo si el traslado se realizó antes de ahora, pero no antes de {since}."
  },
  "refusal": {
    "wardMissing": "Seleccione la unidad a la que se traslada el paciente. El paciente no se ha trasladado.",
    "wardNotFound": "La unidad {ward} no consta en la historia clínica. El paciente no se ha trasladado.",
    "fieldTooLong": "La cama es demasiado larga. Acórtela a un máximo de {max} caracteres. El paciente no se ha trasladado.",
    "movedAtMissing": "Indique cuándo se realizó el traslado. El paciente no se ha trasladado.",
    "movedAtMalformed": "La hora del traslado no se reconoce como una hora. Escríbala como AAAA-MM-DD HH:MM, por ejemplo 2026-10-15 08:00. El paciente no se ha trasladado.",
    "movedAtInFuture": "La hora del traslado está en el futuro. El paciente no se ha trasladado.",
    "beforeCurrent": "El traslado no puede haberse realizado antes de {since}, cuando el paciente llegó a su ubicación actual. El paciente no se ha trasladado.",
    "noChange": "El paciente ya está allí. Seleccione otra unidad o cama. El paciente no se ha trasladado.",
    "stale": "Otra persona ha trasladado al paciente mientras el formulario estaba abierto. La vista general está actualizada: compruebe dónde está ahora el paciente e inténtelo de nuevo. El paciente no se ha trasladado.",
    "notActive": "El paciente ya no está ingresado y no se puede trasladar. El paciente no se ha trasladado.",
    "notFound": "El ingreso no consta en la historia clínica. Vuelva a abrir la vista general del paciente. El paciente no se ha trasladado.",
    "roleMayNotDocument": "Su rol no permite documentar en la historia clínica. El paciente no se ha trasladado.",
    "unknown": "El paciente no se ha trasladado. Inténtelo de nuevo.",
    "unavailable": "Sin conexión con el servidor. No es seguro que el paciente se haya trasladado: vuelva a abrir la vista general del paciente y compruebe dónde está antes de intentarlo de nuevo."
  }
}
